

const clientQuestionTransformer = response => {
  
  const transformedArrayToObject = response?.reduce((acc, obj) => {
    acc[obj?.settings?.key] = obj
    if (!!obj?.children && obj?.children?.length >= 1) {
      obj?.children?.forEach(child => {
        acc[child?.settings?.key] = child
      })
    }
    return acc
  }, {})

  return transformedArrayToObject
}

export default clientQuestionTransformer